var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1417_9239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 18C9.25 17.8011 9.32902 17.6103 9.46967 17.4697C9.61032 17.329 9.80109 17.25 10 17.25H16C16.0663 17.25 16.1299 17.2237 16.1768 17.1768C16.2237 17.1299 16.25 17.0663 16.25 17V5C16.25 4.9337 16.2237 4.87011 16.1768 4.82322C16.1299 4.77634 16.0663 4.75 16 4.75H10C9.80109 4.75 9.61032 4.67098 9.46967 4.53033C9.32902 4.38968 9.25 4.19891 9.25 4C9.25 3.80109 9.32902 3.61032 9.46967 3.46967C9.61032 3.32902 9.80109 3.25 10 3.25H16C16.966 3.25 17.75 4.034 17.75 5V17C17.75 17.4641 17.5656 17.9092 17.2374 18.2374C16.9092 18.5656 16.4641 18.75 16 18.75H10C9.80109 18.75 9.61032 18.671 9.46967 18.5303C9.32902 18.3897 9.25 18.1989 9.25 18Z",
    fill: "#54362B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6126 12.115C13.6126 12.3802 13.5072 12.6346 13.3197 12.8221C13.1321 13.0097 12.8778 13.115 12.6126 13.115H7.75658C7.73358 13.471 7.70458 13.825 7.67058 14.181L7.64058 14.486C7.62941 14.601 7.59067 14.7115 7.52766 14.8083C7.46465 14.9051 7.37922 14.9852 7.27862 15.042C7.17802 15.0987 7.06522 15.1303 6.94979 15.1342C6.83437 15.138 6.71972 15.1139 6.61558 15.064C4.78756 14.1879 3.13269 12.989 1.73058 11.525L1.70058 11.494C1.57186 11.3598 1.5 11.181 1.5 10.995C1.5 10.809 1.57186 10.6303 1.70058 10.496L1.73058 10.465C3.13268 9.001 4.78754 7.80211 6.61558 6.92602C6.71972 6.87609 6.83437 6.85203 6.94979 6.85587C7.06522 6.8597 7.17802 6.89133 7.27862 6.94805C7.37922 7.00478 7.46465 7.08494 7.52766 7.18172C7.59067 7.27851 7.62941 7.38907 7.64058 7.50402L7.67058 7.80902C7.70458 8.16402 7.73358 8.51902 7.75658 8.87502H12.6126C12.8778 8.87502 13.1321 8.98037 13.3197 9.16791C13.5072 9.35545 13.6126 9.6098 13.6126 9.87502V12.115Z",
    fill: "#14B67D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1417_9239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuit);
export default __webpack_public_path__ + "static/media/quit.81c08196507c0cc3d69288905985d453.svg";
export { ForwardRef as ReactComponent };